/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  ShearConnectionCreateDTO,
  ShearConnectionDTO,
} from '../fastAPI.schemas'

/**
 * @summary All Shear Connections
 */
export const allShearConnections = (signal?: AbortSignal) => {
  return customInstance<ShearConnectionDTO[]>({ url: `/shear-connections`, method: 'GET', signal })
}

export const getAllShearConnectionsQueryKey = () => {
  return [`/shear-connections`] as const
}

export const getAllShearConnectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof allShearConnections>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allShearConnections>>, TError, TData>
}) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getAllShearConnectionsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allShearConnections>>> = ({ signal }) =>
    allShearConnections(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allShearConnections>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type AllShearConnectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof allShearConnections>>
>
export type AllShearConnectionsQueryError = HTTPValidationError

/**
 * @summary All Shear Connections
 */

export function useAllShearConnections<
  TData = Awaited<ReturnType<typeof allShearConnections>>,
  TError = HTTPValidationError,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof allShearConnections>>, TError, TData>
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllShearConnectionsQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}

/**
 * @summary Add Shear Connection
 */
export const addShearConnection = (
  shearConnectionCreateDTO: ShearConnectionCreateDTO,
  signal?: AbortSignal,
) => {
  return customInstance<ShearConnectionDTO>({
    url: `/shear-connections`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shearConnectionCreateDTO,
    signal,
  })
}

export const useAddShearConnectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addShearConnection>>,
    TError,
    { data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof addShearConnection>>,
  TError,
  { data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationKey = ['addShearConnection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addShearConnection>>,
    { data: ShearConnectionCreateDTO }
  > = props => {
    const { data } = props ?? {}

    return addShearConnection(data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/shear-connections` },
    {
      operationId: 'add_shear_connection_shear_connections_post',
      operationName: 'addShearConnection',
    },
  )

  return customOptions
}

export type AddShearConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addShearConnection>>
>
export type AddShearConnectionMutationBody = ShearConnectionCreateDTO
export type AddShearConnectionMutationError = HTTPValidationError

/**
 * @summary Add Shear Connection
 */
export const useAddShearConnection = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addShearConnection>>,
    TError,
    { data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof addShearConnection>>,
  TError,
  { data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationOptions = useAddShearConnectionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Delete Shear Connection
 */
export const deleteShearConnection = (connectionId: string) => {
  return customInstance<unknown>({ url: `/shear-connections/${connectionId}`, method: 'DELETE' })
}

export const useDeleteShearConnectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShearConnection>>,
    TError,
    { connectionId: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteShearConnection>>,
  TError,
  { connectionId: string },
  TContext
> => {
  const mutationKey = ['deleteShearConnection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteShearConnection>>,
    { connectionId: string }
  > = props => {
    const { connectionId } = props ?? {}

    return deleteShearConnection(connectionId)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/shear-connections/{connectionId}` },
    {
      operationId: 'delete_shear_connection_shear_connections__connection_id__delete',
      operationName: 'deleteShearConnection',
    },
  )

  return customOptions
}

export type DeleteShearConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteShearConnection>>
>

export type DeleteShearConnectionMutationError = HTTPValidationError

/**
 * @summary Delete Shear Connection
 */
export const useDeleteShearConnection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteShearConnection>>,
    TError,
    { connectionId: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteShearConnection>>,
  TError,
  { connectionId: string },
  TContext
> => {
  const mutationOptions = useDeleteShearConnectionMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * @summary Post Update Shear Connection
 */
export const postUpdateShearConnection = (
  connectionId: string,
  shearConnectionCreateDTO: ShearConnectionCreateDTO,
  signal?: AbortSignal,
) => {
  return customInstance<ShearConnectionDTO>({
    url: `/shear-connections/${connectionId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shearConnectionCreateDTO,
    signal,
  })
}

export const usePostUpdateShearConnectionMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateShearConnection>>,
    TError,
    { connectionId: string; data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof postUpdateShearConnection>>,
  TError,
  { connectionId: string; data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationKey = ['postUpdateShearConnection']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postUpdateShearConnection>>,
    { connectionId: string; data: ShearConnectionCreateDTO }
  > = props => {
    const { connectionId, data } = props ?? {}

    return postUpdateShearConnection(connectionId, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/shear-connections/{connectionId}` },
    {
      operationId: 'post_update_shear_connection_shear_connections__connection_id__post',
      operationName: 'postUpdateShearConnection',
    },
  )

  return customOptions
}

export type PostUpdateShearConnectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postUpdateShearConnection>>
>
export type PostUpdateShearConnectionMutationBody = ShearConnectionCreateDTO
export type PostUpdateShearConnectionMutationError = HTTPValidationError

/**
 * @summary Post Update Shear Connection
 */
export const usePostUpdateShearConnection = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postUpdateShearConnection>>,
    TError,
    { connectionId: string; data: ShearConnectionCreateDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof postUpdateShearConnection>>,
  TError,
  { connectionId: string; data: ShearConnectionCreateDTO },
  TContext
> => {
  const mutationOptions = usePostUpdateShearConnectionMutationOptions(options)

  return useMutation(mutationOptions)
}
